import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import RootErrorBoundary, { clearChunkReloadGuard, installViteChunkReloadListener } from './RootErrorBoundary';
import './pages/globals.css';

clearChunkReloadGuard();
installViteChunkReloadListener();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RootErrorBoundary>
  </React.StrictMode>
);
